export const handleApiError = (error) => {
  // Re-throw abort errors — RTK handles cancelled thunks natively
  if (error.name === 'CanceledError' || error.name === 'AbortError') {
    throw error;
  }
  return error.response?.data?.message || error.message || 'Something went wrong.';
};
